import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    pisLoading : false,
    paxhealths: [],
    totalPaxhealth: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    piscLoading:false,
    pcstatus:"",
    pcMessage:"",
    paxempty:"",
    pdetails:{},
    pismloading:false,
    pmstatus:"",
    pmmessage:"",
    pSDetails: {},
    prdata:{},
    prmdata:{},
    pdstatus:"",
    pdmessage:"",
    error:"",
    paxhealthId:"",
    
};


const paxhealthSlice = createSlice({
    name: "paxhealthList",
    initialState,
    reducers:{
        getPaxhealthPending: (state) => {
            state.pisLoading = true;
        },
        getPaxhealthSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.ppliers = payload;
            state.paxhealths = payload;
           // console.log(payload);
           // state.user="slice userData";
            state.error = '';
        },
        getPaxhealthFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },
        createPaxhealthPending:(state,action) => {
            state.piscLoading=true;
        }, 
        createPaxhealthSuccess:(state,{payload}) => {
            state.piscLoading=false;
            state.paxstatus="success";
            state.paxMessage='Pax and Health Added Successfully';
            state.paxhealthId= payload.id;
            state.prdata= payload;
        },
        createPaxhealthFail:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="fail";
            //console.log('slice '+payload);
            state.pcMessage=payload;
        },
        getSPaxhealthPending: (state) => {
            state.pisLoading = true;
        },
        getSPaxhealthSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.pSDetails=payload;
           
           // state.user="slice userData";
            state.error = '';
        },
        getSPaxhealthFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
            state.paxempty = payload
        },
        modifyPaxhealthPending:(state,action) => {
            state.pismloading=true;
            state.pmstatus="";
        },
        modifyPaxhealthSuccess:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="success";
            state.prmdata= payload;
           
            state.pmmessage="Paxhealth Successfully Updated";
        },
        modifyPaxhealthFail:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="fail";
           // console.log('slice '+payload);
            state.pmmessage=payload;
        },
        deletePaxhealthPending:(state,action) => {
            state.pisLoading=true;
            state.pdstatus="";
        },
        deletePaxhealthSuccess:(state,{payload}) => {
            state.pisLoading=false;
            state.pdstatus="success";
            state.pdmessage="Paxhealth Successfully Deleted";
        },
        deletePaxhealthFail:(state,{payload}) => {
            state.pisLoading=false;
            state.pdstatus="fail";
           // console.log('slice '+payload);
            state.pdmessage=payload;
        },
        reset: (state) => {

            state.piscLoading=false;
            state.pcstatus="false";
            state.pcMessage="";
            state.paxhealthId= "";
        },
        imageUploadSuccess:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="success";
            state.pcMessage=payload.message;
            
        },
        imageUploadFailure:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="fail";
            state.pcMessage=payload.message;
            
        },
    },
});

const { reducer, actions } = paxhealthSlice;

export const { getPaxhealthPending, getPaxhealthSuccess, getPaxhealthFail,getSPaxhealthPending, getSPaxhealthSuccess, getSPaxhealthFail, 
    createPaxhealthPending, createPaxhealthSuccess, createPaxhealthFail,
    modifyPaxhealthPending,modifyPaxhealthSuccess,modifyPaxhealthFail,
    deletePaxhealthPending,deletePaxhealthSuccess,deletePaxhealthFail,reset,imageUploadSuccess,imageUploadFailure} = actions;

export default reducer;
